<div class="chart-type-selector dropdown-shadow radius-l p-4 white-bg">
    <div class="selector-header content-l primary-text py-4">Select Chart Type</div>

    <div class="category-section" *ngFor="let category of widgetbuildervarservice.ListOfCharts">
        <h5 class="category-title secondary-text bolder-text">
            {{ category.display }}
        </h5>

        <ng-container *ngIf="mode == 'selector'">
            <div class="options-grid">
                <div class="option-card enable-action" *ngFor="let option of category.options" [ngClass]="[
          option.value === widgetbuildervarservice.selectorChart
            ? 'border-blue primary-bg'
            : 'border-light white-bg',
          option.enable ? '' : 'permission-denied'
        ]" (click)="onOptionSelect(option)">
                    <img [src]="option.icon" class="option-icon icon-m" />
                    <span class="option-label content-s primary-text bold-text">{{
          option.display
        }}</span>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="mode != 'selector'">
            <div class="options-grid">
                <div class="option-card enable-action" *ngFor="let option of category.options" [ngClass]="[
          option.value === widgetbuildervarservice.chartType
            ? 'border-blue primary-bg'
            : 'border-light white-bg',
          option.enable ? '' : 'permission-denied'
        ]" (click)="onOptionSelect(option)">
                    <img [src]="option.icon" class="option-icon icon-m" />
                    <span class="option-label content-s primary-text bold-text">{{
          option.display
        }}</span>
                </div>
            </div>
        </ng-container>


    </div>
</div>